/** The lists a company manages its own values for. */
export const MANAGED_LIST_KEYS = [
  "lead_source",
  "payment_method",
  "document_type",
  "document_status"
] as const

export type ManagedListKey = (typeof MANAGED_LIST_KEYS)[number]

/** Document Type only — the fixed set the backend's `Icon` choices accept,
 *  the same names @ant-design/icons already uses (its own `data-icon`, e.g.
 *  "file-protect" for `FileProtectOutlined`). Kept here rather than derived
 *  from `document-type-visuals.ts` so this file has no import on a Files
 *  helper — Settings has no other dependency on the Files feature. */
export const MANAGED_LIST_OPTION_ICONS = [
  "file-protect",
  "file-done",
  "account-book",
  "swap",
  "build",
  "question-circle",
  "profile",
  "bar-chart",
  "shopping-cart",
  "calendar",
  "solution",
  "paper-clip"
] as const

export type ManagedListOptionIcon = (typeof MANAGED_LIST_OPTION_ICONS)[number]

export interface ManagedListOption {
  id: string
  list_key: ManagedListKey
  /** Immutable: records store this, so renaming edits `label` instead. */
  value: string
  label: string
  /** Document Type only — blank on every other list. */
  icon: ManagedListOptionIcon | ""
  order: number
  is_active: boolean
  /** Matched by slug somewhere in the code; renameable, never retirable. */
  is_system: boolean
  /** Lead sources only: reveal the free-text "Source details" note. */
  requires_detail: boolean
}

export interface ManagedListOptionPatch {
  label?: string
  icon?: ManagedListOptionIcon | ""
  is_active?: boolean
  requires_detail?: boolean
}
